import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

import en from './en.json';
import fi from './fi.json';
import uk from './uk.json';
import ru from './ru.json';

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fi: { translation: fi },
      uk: { translation: uk },
      ru: { translation: ru },
    },
    lng: detectInitialLocale(),
    fallbackLng: 'en',
    supportedLngs: ['en', 'fi', 'uk', 'ru'],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

function detectInitialLocale(): string {
  if (typeof navigator === 'undefined') return 'en';
  const langs = navigator.languages ?? [navigator.language];
  for (const l of langs) {
    const base = l.toLowerCase().split('-')[0];
    if (['en', 'fi', 'uk', 'ru'].includes(base)) return base;
  }
  return 'en';
}

export default i18n;
